import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaPinterestP, FaArrowRight } from 'react-icons/fa';
import './FooterNew.css';
import Logo from '../../../assets/images/The Pickers Stop LOGO.png'
import { categoryData } from '../../../constant/categoryData';

const FooterNew: React.FC = () => {
    const categories = Object.keys(categoryData);

    return (
        <footer className="footer-new">
            <div className="container">
                <div className="footer-top">
                    {/* Brand Column */}
                    <div className="footer-brand">
                        <Link to="/" className="footer-logo no-underline">
                            <img src={Logo} alt="The Pickers Stop" style={{ maxHeight: '60px', width: 'auto' }} />
                        </Link>
                        <p className="brand-statement">
                            Your one-stop solution for all office and corporate needs.
                            Quality products, trusted brands, delivered to your doorstep.
                        </p>
                        <div className="social-links">
                            <a href="#" aria-label="Facebook"><FaFacebookF /></a>
                            <a href="#" aria-label="Twitter"><FaTwitter /></a>
                            <a href="#" aria-label="Instagram"><FaInstagram /></a>
                            <a href="#" aria-label="Pinterest"><FaPinterestP /></a>
                        </div>
                    </div>

                    {/* Navigation Columns */}
                    <div className="footer-nav-group">
                        <div className="footer-nav-col">
                            <h4>Shop Categories</h4>
                            <ul>
                                {categories.map((cat) => (
                                    <li key={cat}>
                                        <Link to={`/shop?category=${encodeURIComponent(cat)}`}>{cat}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="footer-nav-col">
                            <h4>Company</h4>
                            <ul>
                                <li><Link to="/about">Our Story</Link></li>
                                <li><Link to="/blog">Blog</Link></li>
                                <li><Link to="/contact">Contact Us</Link></li>
                            </ul>
                        </div>

                        {/* <div className="footer-nav-col">
                            <h4>Support</h4>
                            <ul>
                                <li><Link to="/faq">FAQs</Link></li>
                                <li><Link to="/shipping">Shipping & Returns</Link></li>
                                <li><Link to="/care">Care Guide</Link></li>
                                <li><Link to="/warranty">Warranty</Link></li>
                            </ul>
                        </div> */}
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} The Pickers Stop. All rights reserved.</p>
                    <div className="legal-links">
                        <Link to="/privacy">Privacy Policy</Link>
                        <Link to="/terms">Terms of Service</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default FooterNew;
